import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ListView, Badge, Card, WingBlank, WhiteSpace, Picker, List, Button, Modal, InputItem, Toast, ActionSheet, Calendar } from 'antd-mobile';
import TipPlaceholder from '../components/TipPlaceholder';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import { createForm } from 'rc-form';
import CommonUtils from '../utils/CommonUtils';
import '../styles/OrderPage.css';

const alert = Modal.alert
class OrderPage extends Component {
    static defaultProps = {
        fetchSites: (params, callback) => {},
        fetchOrders: (params, callback) => {},
        fetchDeviceTypes: (params, callback) => {},
        sendGift: (params, callback, completed) => {},
        refund: (params, callback) => {},
        delegateProfile: (params, callback) => {},
        bindRefreshFunc: (func) => {}
    }

    constructor(props) {
        super(props);

        let dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            dataSource,
            isLoading: true,
            hasMore: true,
            height: document.documentElement.clientHeight * 3 / 4,
            selectedItem: null,
            sites: [],
            selectedSite: '',
            showCalendar: false,
            dateRange: {
                start: new Date(),
                end: new Date()
            },
            showGiftModal: false,
            enableGift: true,
            deviceType: '',
            delegateProfile: null,
            deviceTypes: []
        };
    }

    componentDidMount() {
        let height = document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop - 60;
        this.setState({
            height
        })
        this.props.bindRefreshFunc(this.loadInitData)
        this.loadInitData()
    }

    loadInitData = () => {
        this.setState({
            isLoading: true,
            hasMore: true,
            selectedItem: null,
            selectedSite: '',
            deviceType: ''
        }, () => {
            this.props.delegateProfile({}, (resp) => {
                this.setState({
                    delegateProfile: resp.data
                })
            })
            this.loadSites()
            this.loadDeviceTypes()
            this.loadPageData(1)
        })
    }

    loadPageData = (pageNum, listViewHeight) => {
        const { selectedSite, dateRange, deviceType } = this.state
        const params = {
            pageNum,
            pageSize: 10,
            siteId: selectedSite,
            fromDate: CommonUtils.formatDate(dateRange.start),
            toDate: CommonUtils.formatDate(dateRange.end),
            deviceType
        }
        this.props.fetchOrders(params, (resp) => {
            let data = resp.data
            this.pageNum = data.pageNum;
            this.pageSize = data.pageSize;
            this.pages = data.pages;
            let oldRowDatas = this.rowDatas&&pageNum>1 ? this.rowDatas : {}
            this.rowDatas = {...oldRowDatas, ...this.wrapIntoRowDatas(data.result)};
            this.setState({
                dataSource: this.state.dataSource.cloneWithRows(this.rowDatas),
                isLoading: false,
                hasMore: this.pageNum < this.pages
            })
        })
    }

    loadSites = (callback) => {
        this.props.fetchSites({}, (resp) => {
            this.setState({
                sites: resp.data
            }, () => {
                callback&&callback()
            })
        })
    }

    loadDeviceTypes = () => {
        this.props.fetchDeviceTypes({}, (resp) => {
            this.setState({
                deviceTypes: resp.data
            })
        })
    }

    onEndReached = (event) => {
        const { isLoading, hasMore } = this.state

        if (isLoading || !hasMore) {
            return;
        }

        this.setState({ isLoading: true });
        this.loadPageData(++this.pageNum)
    }

    onSitePickerChange = (val) => {
        this.setState({
            selectedSite: val[0]
        }, () => {
            this.loadPageData(1)
        })
    }

    onDeviceTypePickerChange = (val) => {
        this.setState({
            deviceType: val[0]
        }, () => {
            this.loadPageData(1)
        })
    }

    onCalendarConfirm = (startDate, endDate) => {
        this.setState({
            showCalendar: false,
            dateRange: {
                start: startDate,
                end: endDate
            }
        }, () => {
            this.loadPageData(1)
        })
    }

    onCalendarCancel = () => {
        this.setState({
            showCalendar: false
        })
    }

    handleItemClick = (rowData) => {
        const { delegateProfile } = this.state

        const options = []
        if(!delegateProfile || delegateProfile.delegateType === 'OPERATOR') {
            options.push({ icon: <i className='iconfont icon-youxiyouxiji' style={{color:'#04bbc5', fontSize: 30}}/>, title: '赠送时间' })
            if(rowData.canRefund&&rowData.refundStatus!=='SUCCESS') {
                options.push({ icon: <i className='iconfont icon-tuikuan' style={{color:'orange', fontSize: 30}}/>, title: '退款' })
            }
        }
        
        if(!options.length) {
            Toast.info('无操作权限')
            return
        }

        let optionMap = {}
        for(let i = 0; i < options.length; i++) {
            optionMap[i] = options[i].title
        }
        ActionSheet.showShareActionSheetWithOptions({
            options,
            title: '操作',
            message: `${rowData.userNickName}  ${rowData.orderNo}`,
        },
        (buttonIndex) => {
            let buttonTitle = optionMap[buttonIndex]
            if(!buttonTitle) return

            if(buttonTitle === '赠送时间') {
                this.setState({
                    showGiftModal: true,
                    selectedItem: rowData
                })
            } else if(buttonTitle === '退款') {
                this.handleRefundClick(rowData)
            } else {
                Toast.info('功能开发中')
            }
        });
    }

    handleGiftClick = () => {
        const { selectedItem } = this.state
        if(!selectedItem) return

        this.setState({
            enableGift: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            const propPrefix = 'gift_'
            if(error) {
                for(let prop in error) {
                    if(prop.indexOf(propPrefix) !== 0) {
                        continue
                    }

                    let item = error[prop]
                    if(item.errors && item.errors.length) {
                        Toast.fail(item.errors[0].message)
                        this.setState({
                            enableGift: true
                        })
                        return
                    }
                }
            }

            const params = {
                userId: selectedItem.userId,
                siteId: selectedItem.siteId,
                deviceType: selectedItem.deviceType
            }
            for(let prop in fieldsValue) {
                if(prop.indexOf(propPrefix) !== 0) {
                    continue
                }
                let propValue = fieldsValue[prop]
                if(Array.isArray(propValue)) {
                    propValue = propValue[0]
                }
                params[prop.substring(propPrefix.length)] = propValue
            }

            this.props.sendGift(params, (resp) => {
                this.setState({
                    showGiftModal: false
                })
                this.props.form.resetFields()
                Toast.info('时间已送出')
            }, () => {
                this.setState({
                    enableGift: true
                })
            })
        });
    }

    handleRefundClick = (rowData) => {
        alert('确认要退款?', `${rowData.userNickName} ￥${rowData.originalAmount}`, [
            { text: '取消', onPress: () => {} },
            { text: '确认', onPress: () => {
                const params = {
                    orderNo: rowData.orderNo
                }
                this.props.refund(params, (resp) => {
                    Toast.info('退款处理中')
                    this.loadPageData(1)
                })
            }},
          ])
    }

    wrapIntoRowDatas(datas) {
        if (!datas||datas.length<=0) {
            return {};
        }

        let rowDatas = {};
        datas.forEach((data, index) => {
            let id = this.pageNum*this.pageSize + index
            rowDatas[id] = data;
        })
        return rowDatas;
    }

    renderFooter = (isLoading) => {
        if(isLoading) {
            return <LoadingPlaceholder/>
        }

        const { dataSource } = this.state
        if(dataSource.getRowCount()) {
            return <div></div>
        }

        return <TipPlaceholder firstTip='暂无数据'/>
    }

    renderSeparator(sectionId, rowId) {
        return <WhiteSpace key={rowId}/>
    }

    doResolveOrderType = (record) => {
        if(record.operateType === 'SOLD_CASH_PACKET') {
            return '游戏套餐(微信)'
        } else if(record.operateType === 'SOLD_COUPON_PACKET') {
            return '游戏套餐(余额)'
        } else if(record.operateType === 'SOLD_RECHARGE') {
            return '优惠充值'
        } else if(record.operateType === 'TEAM_SOLD_CASH_PACKET') {
            return '团队提成(游戏)'
        } else if(record.operateType === 'TEAM_SOLD_RECHARGE') {
            return '团队提成(充值)'
        } else if(record.operateType === 'SOLD_COUPON') {
            return '优惠活动'
        } else if(record.operateType === 'TEAM_SOLD_COUPON') {
            return '团队提成(活动)'
        }
    }

    doResolveOrderDevice = (record) => {
        if(CommonUtils.isNotEmpty(record.deviceName)) {
            return record.deviceName
        }

        if(CommonUtils.isNotEmpty(record.couponCode)) {
            return '优惠券' + record.couponCode
        }

        return '未知'
    }

    resolveJoinDaysInfo = (rowData) => {
        return CommonUtils.resolveJoinDaysInfo(rowData.userJoinDays)
    }

    renderRow = (rowData, sectionId, rowId) => {
        let extra = (<div><span className='unit'>￥</span><span className='value'>{rowData.profitAmount}</span></div>)
        if(rowData.refundStatus === 'PROCESSING') {
            extra = (<Badge text="退款中"style={{backgroundColor: 'gray'}}/>)
        } else if(rowData.refundStatus === 'SUCCESS') {
            extra = (<Badge text="已退款"style={{backgroundColor: 'gray'}}/>)
        }

        let title = (<span className='word-ellipsis'>&nbsp;{rowData.userNickName}</span>)
        if(!rowData.newUser) {
            title = (<span className='word-ellipsis'>&nbsp;{rowData.userNickName} <Badge text="复购" style={{backgroundColor:'#04bbc5'}}/></span>)
        }
        if(rowData.virtualUser) {
            title = (<span className='word-ellipsis'>&nbsp;{rowData.userNickName} <Badge text="小号" style={{backgroundColor:'#04bbc5'}}/></span>)
        }

        return (
            <WingBlank size='sm'>
                <div onClick={() => {this.handleItemClick(rowData)}}>
                    <Card key={rowId}>
                        <Card.Header
                            title={title}
                            thumb={<img src={rowData.userAvatar} alt='avatar'/>}
                            extra={extra}
                        />
                        <Card.Body>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>订单价格：</span> 
                                    <span className='value'>￥{rowData.originalAmount}</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>订单类型：</span> 
                                    <span className='value'>{this.doResolveOrderType(rowData)}</span>
                                </div>
                            </div>
                            <div className='info-row'>
                                {rowData.operateType==='SOLD_RECHARGE'||rowData.operateType==='TEAM_SOLD_RECHARGE'?(
                                    <div className='info-column word-ellipsis'>
                                        <span className='label'>赠送金额：</span> 
                                        <span className='value'>￥{rowData.giftAmount}</span>
                                    </div>
                                ):(
                                    <div className='info-column word-ellipsis'>
                                        <span className='label'>游戏时间：</span> 
                                        <span className='value'>{rowData.gameMinutes}分钟</span>
                                    </div>
                                )}
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>消费门店：</span> 
                                    <span className='value'>{rowData.siteName}</span>
                                </div>
                            </div>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>订单分成：</span> 
                                    <span className='value'>{rowData.profitPoint}%</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>下单时间：</span> 
                                    <span className='value'>{CommonUtils.shortenDateTime(rowData.createTime)}</span>
                                </div>
                            </div>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>剩余时间：</span> 
                                    <span className='value'>{CommonUtils.readableGameMinutes(rowData.userGameMinutes)}</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>账户余额：</span> 
                                    <span className='value'>￥{rowData.userBalance}</span>
                                </div>
                            </div>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>注册时间：</span> 
                                    <span className='value'>{this.resolveJoinDaysInfo(rowData)}</span>
                                </div>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>设备类型：</span> 
                                    <span className='value'>{CommonUtils.resolveDictText(rowData.deviceType, this.state.deviceTypes, 'code', 'name')}</span>
                                </div>
                            </div>
                            {rowData.refundStatus==='FAIL'?(<div className='refund-tip word-ellipsis'>退款失败{rowData.refundRemark?'：'+rowData.refundRemark:''}</div>):null}
                        </Card.Body>
                        <Card.Footer content={<div className='tip' style={{paddingTop: 2}}><i className='iconfont icon-diannao' style={{fontSize: 10}}/>&nbsp;{this.doResolveOrderDevice(rowData)}</div>} extra={<span className='word-ellipsis'>{rowData.orderNo}</span>}/>
                    </Card>
                </div>
            </WingBlank>
        )
    }

    doRenderGiftModal = () => {
        const { getFieldProps } = this.props.form;
        const { showGiftModal, enableGift, selectedItem } = this.state
        
        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showGiftModal}
                    onClose={() => {
                        this.setState({showGiftModal: false})
                        this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" renderHeader={() => <div className='modal-title'>赠送时间</div>}>
                        <InputItem disabled {...getFieldProps('gift_userNickName', {
                            initialValue: selectedItem?selectedItem.userNickName:null,
                        })}>
                            用户
                        </InputItem>
                        <InputItem disabled {...getFieldProps('gift_deviceTypeName', {
                            initialValue: selectedItem?CommonUtils.resolveDictText(selectedItem.deviceType, this.state.deviceTypes, 'code', 'name'):null,
                        })}>
                            类型
                        </InputItem>
                        <InputItem disabled {...getFieldProps('gift_orderNo', {
                            initialValue: selectedItem?selectedItem.orderNo:null,
                        })}>
                            订单
                        </InputItem>
                        <InputItem type='number' extra="分钟" {...getFieldProps('gift_gameMinutes', {
                            initialValue: selectedItem?selectedItem.gameMinutes:null,
                            rules: [{required: true, message: '请填写时间'}],
                        })}>
                            时间
                        </InputItem>
                        <InputItem {...getFieldProps('gift_remark', {
                            initialValue: selectedItem?`订单${selectedItem.orderNo}赠送`:null,
                        })}>
                            备注
                        </InputItem>
                        <List.Item>
                            <Button type="primary" onClick={this.handleGiftClick} disabled={!enableGift}>提交</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    doRenderFilterView = () => {
        const { sites, selectedSite, dateRange, deviceType, deviceTypes } = this.state;
        const sitePickerData = sites.map(item => ({value: item.id, label: item.siteName}))
        const deviceTypePickerData = CommonUtils.generatePickerOptionsFromList(deviceTypes, 'code', 'name')
        return (
            <div className='wrapper-filter'>
                <WingBlank size='sm'>
                    <Picker 
                        cols={1}
                        value={[selectedSite]}
                        onOk={this.onSitePickerChange}
                        data={[{label:'所有门店', value:''}, ...sitePickerData]}>
                        <List.Item arrow="horizontal" className='title'>
                            <i className='iconfont icon-guolv'/>
                            <span> 筛选</span>
                        </List.Item>
                    </Picker>
                    <div className='filters'>
                        <div className='date-range-picker' onClick={() => {
                            this.setState({
                                showCalendar: true
                            })
                        }}>
                            <span className='symbol'>
                                <i className='iconfont icon-rili'/>
                            </span>
                            <span className='date'>{CommonUtils.formatDate(dateRange.start)}</span>
                            <span className='seperator'>~</span>
                            <span className='date'>{CommonUtils.formatDate(dateRange.end)}</span>
                        </div>
                        <div className='device-type-picker'>
                            <Picker
                                cols={1}
                                value={[deviceType?deviceType:'']}
                                onOk={this.onDeviceTypePickerChange}
                                data={[{label:'所有设备', value: ''}, ...deviceTypePickerData]}>
                                <List.Item></List.Item>
                            </Picker>
                        </div>
                    </div>
                </WingBlank>
            </div>
        )
    }

    render() {
        const { dataSource, isLoading, showCalendar, dateRange } = this.state;

        return (
            <div className='order-page'>
                {this.doRenderFilterView()}
                <ListView
                    ref={el => this.lv = el}
                    dataSource={dataSource}
                    renderFooter={() => this.renderFooter(isLoading)}
                    renderRow={this.renderRow}
                    renderSeparator={this.renderSeparator}
                    pageSize={8}
                    scrollRenderAheadDistance={500}
                    onEndReached={this.onEndReached}
                    onEndReachedThreshold={10}
                    style={{
                        height: this.state.height,
                        overflow: 'auto',
                        paddingTop: 120
                    }}
                />
                <Calendar
                    visible={showCalendar}
                    showShortcut={true}
                    initalMonths={12}
                    infinite={false}
                    onCancel={this.onCalendarCancel}
                    onConfirm={this.onCalendarConfirm}
                    defaultValue={[dateRange.start, dateRange.end]}
                    maxDate={new Date()}
                />
                {this.doRenderGiftModal()}
            </div>
        )
    }
}

export default createForm()(OrderPage);


// WEBPACK FOOTER //
// ./src/components/OrderPage.js